import React from 'react';
import Lottie from 'lottie-react';
import { Box, Typography } from '@mui/material';
import lmsLoadingAnimation from '../../assets/animations/lms-loading.json';
import learnerWaitingAnimation from '../../assets/animations/learner_waiting.json';

interface LottieLoadingProps {
    message?: string;
    fullScreen?: boolean;
    size?: number;
    animationType?: 'default' | 'learner';
}

/**
 * A reusable loading component that displays the LMS Lottie animation.
 * Used during authentication loading and application initialization.
 */
const LottieLoading: React.FC<LottieLoadingProps> = ({
    message = 'Chargement...',
    fullScreen = true,
    size = 200,
    animationType = 'default'
}) => {
    const animationData = animationType === 'learner' ? learnerWaitingAnimation : lmsLoadingAnimation;

    const containerStyles = fullScreen ? {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        zIndex: 9999,
    } : {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
    };

    return (
        <Box sx={containerStyles}>
            <Box
                sx={{
                    width: size,
                    height: size,
                    mb: 2,
                }}
            >
                <Lottie
                    animationData={animationData}
                    loop={true}
                    autoplay={true}
                    style={{ width: '100%', height: '100%' }}
                />
            </Box>
            {message && (
                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: 'Quicksand, sans-serif',
                        fontWeight: 500,
                        color: '#555',
                        textAlign: 'center',
                        animation: 'pulse 1.5s ease-in-out infinite',
                        '@keyframes pulse': {
                            '0%, 100%': { opacity: 0.6 },
                            '50%': { opacity: 1 },
                        },
                    }}
                >
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export default LottieLoading;
